import { makeStyles } from '@material-ui/core/styles'
import { BREAKPOINTS, COLORS } from '../../../constants'

export const styles = makeStyles(theme => ({
  modal: {
    outline: 'none',
    maxWidth: '100%',
    width: '100%',
    margin: '0 auto',
    color: theme.palette.common.black,
    ['& .ReactModal__Overlay']: {
      position: 'absolute',
    },
    [`@media (min-width: ${BREAKPOINTS.mdd}px)`]: {
      maxWidth: 420,
    },
  },
  modalContainer: {
    position: 'relative',
    outline: 'none',
    paddingTop: 40,
    paddingBottom: 60,
    paddingRight: 20,
    paddingLeft: 20,
  },
  closeButton: {
    position: 'absolute',
    top: 18,
    right: 10,
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    zIndex: 2,
    outline: 'none',
  },
  modalTitle: {
    marginBottom: 20,
    textAlign: 'center',
  },
  inputContainer: {
    marginBottom: 25,
    position: 'relative',
  },
  errorMsg: {
    color: COLORS.dangerRed,
    position: 'absolute',
    left: 0,
    top: -20,
    fontSize: '0.875rem',
    margin: 0,
  },
  buttonContainer: {
    marginTop: 40,
    position: 'relative',
  },
  successMsg: {
    color: COLORS.successGreen,
    position: 'absolute',
    left: 0,
    bottom: -55,
    fontSize: '0.875rem',
    margin: 0,
  },
}))
